var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.816536 12C0.560981 12 0.372092 11.8889 0.24987 11.6667C0.127648 11.4444 0.127648 11.2222 0.24987 11L6.41654 0.333333C6.53876 0.111111 6.7332 0 6.99987 0C7.26654 0 7.46098 0.111111 7.5832 0.333333L13.7499 11C13.8721 11.2222 13.8721 11.4444 13.7499 11.6667C13.6276 11.8889 13.4388 12 13.1832 12H0.816536ZM6.99987 4.66667C6.81098 4.66667 6.65276 4.73044 6.5252 4.858C6.3972 4.986 6.3332 5.14444 6.3332 5.33333V7.33333C6.3332 7.52222 6.3972 7.68044 6.5252 7.808C6.65276 7.936 6.81098 8 6.99987 8C7.18876 8 7.3472 7.936 7.4752 7.808C7.60276 7.68044 7.66654 7.52222 7.66654 7.33333V5.33333C7.66654 5.14444 7.60276 4.986 7.4752 4.858C7.3472 4.73044 7.18876 4.66667 6.99987 4.66667ZM6.99987 10C7.18876 10 7.3472 9.936 7.4752 9.808C7.60276 9.68044 7.66654 9.52222 7.66654 9.33333C7.66654 9.14444 7.60276 8.98622 7.4752 8.85867C7.3472 8.73067 7.18876 8.66667 6.99987 8.66667C6.81098 8.66667 6.65276 8.73067 6.5252 8.85867C6.3972 8.98622 6.3332 9.14444 6.3332 9.33333C6.3332 9.52222 6.3972 9.68044 6.5252 9.808C6.65276 9.936 6.81098 10 6.99987 10ZM1.96654 10.6667H12.0332L6.99987 2L1.96654 10.6667Z",
    fill: "#FFAA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.a8d111bff39b19a8817db815bc7bbd54.svg";
export { ForwardRef as ReactComponent };